module.exports = "data:image/jpeg;base64,eyJlcnJvciI6IlRvb01hbnlSZXF1ZXN0cyIsIm1lc3NhZ2UiOiJZb3VyIG1vbnRobHkgbGltaXQgaGFzIGJlZW4gZXhjZWVkZWQuIn0="